import { CategorySection } from './CategorySection'
import { withCategorySection } from './withCategorySection'

const ConnectedCategorySection = withCategorySection(CategorySection)

export { ConnectedCategorySection as CategorySection }
